(() => {
  if (customElements.get('lakeside-merchandising')) return;
  class LakesideMerchandising extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.version = (this.version || 0) + 1;
      this.load();
    }
    disconnectedCallback() { this.version++; this.started = false; }
    async request(url) {
      const response = await fetch(url, { signal: AbortSignal.timeout(10000), credentials: 'same-origin' });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return response.text();
    }
    importCard(card) {
      const imported = document.importNode(card, true);
      for (const node of [imported, ...imported.querySelectorAll('*')]) {
        for (const attr of [...node.attributes]) {
          if (/lakeside-(best-seller|recommendation)-feed/.test(attr.value)) {
            node.setAttribute(attr.name, attr.value.replace(/lakeside-(best-seller|recommendation)-feed/g, this.dataset.sectionId));
          }
        }
      }
      return imported;
    }
    async load() {
      const version = ++this.version;
      const container = this.querySelector('[data-ls-cards]');
      const { mode, currentProduct, limit } = this.dataset;
      if (!container || !currentProduct) return;
      let url;
      if (mode === 'best_sellers') {
        if (this.dataset.ranked === 'true' || !this.dataset.collectionUrl) return;
        url = new URL(this.dataset.collectionUrl, location.origin);
        url.search = new URLSearchParams({ section_id: 'lakeside-best-seller-feed', sort_by: 'best-selling' });
      } else if (['related', 'complementary'].includes(mode) && this.dataset.manual !== 'true') {
        url = new URL(this.dataset.recommendationsUrl, location.origin);
        url.search = new URLSearchParams({ section_id: 'lakeside-recommendation-feed', product_id: currentProduct, limit: '10', intent: this.dataset.intent });
      } else return;
      this.setAttribute('aria-busy', 'true');
      try {
        const doc = new DOMParser().parseFromString(await this.request(url), 'text/html');
        if (version !== this.version || !this.isConnected) return;
        const selected = [], seen = new Set([currentProduct]);
        for (const card of doc.querySelectorAll('[data-ls-feed] [data-ls-product-id]')) {
          const id = card.dataset.lsProductId;
          if (!id || seen.has(id)) continue;
          seen.add(id); selected.push(this.importCard(card));
          if (selected.length >= Number(limit)) break;
        }
        container.replaceChildren(...selected);
        if (selected.length) { this.hidden = false; this.querySelector('[data-ls-note]')?.remove(); }
        else if (!window.Shopify?.designMode) this.hidden = true;
      } catch (error) {
        console.warn('Lakeside PDP recommendations unavailable:', error.message);
      } finally {
        if (version === this.version) this.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('lakeside-merchandising', LakesideMerchandising);
})();
